import './styles/zones.scss';
import './zone.js';
import './controllers/zoneController.js';
import './controllers/zonePopoverController.js';
import './directives/zoneDirectives.js';
import './services/zoneService.js';
export default 'zone';